function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
    this.input.addEventListener('input', function (evt) {
       document.querySelector('#hidden-qnt').value = this.value;
      });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    document.querySelector('#hidden-qnt').value = this.input.value;
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    let final_total_price = 0;
    const money_format_function = function(t,r){function e(t,r){return void 0===t?r:t}function a(t,r,a,o){if(r=e(r,2),a=e(a,","),o=e(o,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(r);var n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+a)+(n[1]?o+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var o="",n=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(n)[1]){case"amount":o=a(t,2);break;case"amount_no_decimals":o=a(t,0);break;case"amount_with_comma_separator":o=a(t,2,".",",");break;case"amount_with_space_separator":o=a(t,2," ",",");break;case"amount_with_period_and_space_separator":o=a(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=a(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=a(t,0,".","");break;case"amount_with_space_separator":o=a(t,2,",","");break;case"amount_with_apostrophe_separator":o=a(t,2,"'",".")}return i.replace(n,o)};
    const shop_currency = document.querySelector('body').getAttribute('data-currency');
    if(document.querySelector('.variant_values_purchase')){
      document.querySelectorAll('.variant_values_purchase .variant__values_outer_div').forEach(function(this_val, index){
        let product_price = this_val.querySelector('.quantity__input').getAttribute('data-price');
        let product_qty = this_val.querySelector('.quantity__input').value;
        if(product_qty > 0){
          final_total_price = final_total_price + (product_price * product_qty);
        }
        if(index === (document.querySelectorAll('.variant_values_purchase .variant__values_outer_div').length - 1)){
          document.querySelector('.varaint__tottal_price').innerHTML = '<strong> + '+money_format_function(final_total_price, shop_currency)+'</strong>';
           $('.affirm-as-low-as').attr('data-amount',final_total_price);
          affirm.ui.refresh();
        }
      });
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.container = document.querySelector('.product_section_top_row');
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateProductForm();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    this.container.dispatchEvent(
      new CustomEvent('theme:variant:change', {
        detail: {
          variant:  this.currentVariant
        }
      })
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
        

  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
   
    var data_id_var = this.currentVariant.id;
    $('.images-list-wc figure').removeClass('active');
    $('.images-list-wc figure').each(function(){
    var data_id = $(this).data('id');
    if(data_id_var == data_id){
    $(this).addClass('active');
    }
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
    
      if (
        typeof preOrderVariants === 'object' &&
        preOrderVariants !== null &&
        preOrderVariants.hasOwnProperty(this.currentVariant.id)
      ) {
        const variantData = preOrderVariants[this.currentVariant.id] || { quantity: 0, arrivalDate: '' };
        const preorderInputId = 'preorder-input';
        
        const quantityEl = document.querySelector('.product-form__quantity');
        const formEl = document.querySelector('.product-form');
        const buttonsWrapper = document.querySelector('.product-form .product-form__buttons');
        const submitBtn = document.querySelector('.product-form__submit');
        const preorderText = document.querySelector('.preorder-text');
        
        if (this.currentVariant?.available) {
          quantityEl?.classList.remove("hidden");
          formEl?.classList.remove("product-sold-out");
        
          submitBtn?.classList.remove("sold-out");
          submitBtn.disabled = false;
        
          if (variantData.quantity && variantData.quantity !== 0) {
            input.classList.add('pre-order');
            submitBtn.textContent = 'Pre-Order';
            preorderText?.classList.remove('hidden');
        
            if (variantData.arrivalDate) {
              document.querySelector('.preorder-text .pre-order-date').textContent = variantData.arrivalDate;
            }
        
            let preorderInput = document.getElementById(preorderInputId);
            if (!preorderInput) {
              preorderInput = document.createElement('input');
              preorderInput.type = 'hidden';
              preorderInput.name = 'properties[Ship Date]';
              preorderInput.id = preorderInputId;
              if (buttonsWrapper) {
                buttonsWrapper.prepend(preorderInput);
              }
            }
            preorderInput.value = variantData.arrivalDate;
        
          } else {
            input.classList.remove('pre-order');
            submitBtn.textContent = 'Add to cart';
            preorderText?.classList.add('hidden');
        
            const existingInput = document.getElementById(preorderInputId);
            if (existingInput) {
              existingInput.remove();
            }
          }
        
        } else {
          quantityEl?.classList.add("hidden");
          formEl?.classList.add("product-sold-out");
        
          if (submitBtn) {
            submitBtn.classList.add("sold-out");
            submitBtn.disabled = true;
            submitBtn.textContent = 'Sold out';
          }
        
          preorderText?.classList.add('hidden');
          input.classList.remove('pre-order');
          const existingInput = document.getElementById(preorderInputId);
          if (existingInput) {
            existingInput.remove();
          }
        }
      }
    
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
	$('.product-form__input--color').removeClass('show_with_full_opacity');
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
        pickUpAvailability.classList.remove("this_is__unavailable");
    } else {
      if(!this.currentVariant){
      } else{
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
        pickUpAvailability.classList.add("this_is__unavailable");
      }
    }
  }
  updateProductForm() {
    const productForm = document.querySelector('[data-form-container]');
    if (!productForm.classList.contains('parentForm')) {
      fetch(`${window.routes.root_url}variants/${this.currentVariant.id}/?section_id=api-pdp-form`)
      .then((response) => response.text())
      .then((text) => {
        const formHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-content]').innerHTML;
        productForm.innerHTML = formHTML;
      })
      .catch((e) => {
        console.error(e);
      });
    }
  }
  MatchHeight() {
    $('.product_section_grids').matchHeight({});
  }
  renderProductInfo() {
        var clicked_option_title = this.currentVariant.title;
        $(".dropdown_menu_swatch .dropdown_swatch_button").text(clicked_option_title);
        
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const id__1 = `price-${this.dataset.section}_1`;
        const id__2 = `price-${this.dataset.section}_2`;


        MatchHeight();
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);


        const destination__1 = document.getElementById(id__1);
        const source__1 = html.getElementById(id__1);
        const destination__2 = document.getElementById(id__2);
        const source__2 = html.getElementById(id__2);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source__1 && destination__1) destination__1.innerHTML = source__1.innerHTML;
        if (source__2 && destination__2) destination__2.innerHTML = source__2.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        var variant__price_new = $('.product__description_detailing .price__regular dd .price-item--regular.d_lead_1').attr("data-price");
        $('.data-pp-message_new').attr('data-pp-amount', variant__price_new);
        var radioValue = $(".product-form__input--color .variant_values input:checked").val();
        $(".dropdown_menu_swatch .dropdown_swatch_button").text(radioValue);
      });

      if (
        !(
          typeof preOrderVariants === 'object' &&
          preOrderVariants !== null &&
          preOrderVariants.hasOwnProperty(this.currentVariant.id)
        )
      ) {
        const quantityEl = document.querySelector('.product-form__quantity');
        const formEl = document.querySelector('.product-form');
        const submitBtn = document.querySelector('.product-form__buttons .product-form__submit');
      
        if (this.currentVariant?.available) {
          quantityEl?.classList.remove("hidden");
          formEl?.classList.remove("product-sold-out");
      
          if (submitBtn) {
            submitBtn.classList.remove("sold-out");
            submitBtn.disabled = false;
            submitBtn.textContent = 'Add to cart';
          }
        } else {
          quantityEl?.classList.add("hidden");
          formEl?.classList.add("product-sold-out");
      
          if (submitBtn) {
            submitBtn.classList.add("sold-out");
            submitBtn.disabled = true;
            submitBtn.textContent = 'Sold out';
          }
        }
      }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
	const addButton_new = document.getElementById(`sticky__form--n`)?.querySelector('[name="add"]');


    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
	  if(addButton.classList.contains('appikon-pre-order-button')){
        addButton.textContent = "Pre Order";
		$('.product__pickup-availabilities').hide();
	  }else{
		$('.product__pickup-availabilities').show();
	  }
    }

    var variant_price_affirm = $('.product__description_detailing .price__regular dd .price-item--regular.d_lead_1').attr("data-affirm");
    $('.affirm-as-low-as').attr('data-amount',variant_price_affirm);
    if(affirm && affirm.ui && affirm.ui.refresh){
      affirm.ui.refresh();
    }
    if (!addButton_new) return;

    if (disable) {
      addButton_new.setAttribute('disabled', true);
    if (text) addButton_new.textContent = text;
    } else{
      addButton_new.removeAttribute('disabled');
      addButton_new.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
    
    var length_options = $('.product__desc__var_quan_row variant-radios fieldset').length;
    if(length_options == 2){
      $(".product-form__input--dropdown.option2 label.is-active:eq( 0 )").trigger('click');
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;

  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

$(document).on("click",".variant__input--color-swatch",function(){
  var curVal = $(this).val();
  var color = $(this).next().css("background-color");
  $('.select__select_color > option').removeAttr('selected','selected');
  $(".select__select_color > option").each(function(){
  	var selVal = this.value
    if(curVal == selVal ){

      $(this).attr('selected','selected');
    }
  });
});

function recursive(){
  var get_product_form_submit_cls = document.querySelector('.appikon-pre-order-button');
  if(get_product_form_submit_cls){
   if($(".product-form__submit.deafultcart").hasClass("appikon-pre-order-button")){
      $('.product__pickup-availabilities').hide();
    } else{
      ut(function(){
        recursive();
      },300);
    }
  }
}

var eachvalarray = [];
$('.select__select___ option').each(function(){
  var eachval = $(this).data('label');         
  eachvalarray.push(eachval);
});

var length_options = $('.product__desc__var_quan_row variant-radios fieldset').length;
// $(document).on("click",".product-form__input.option1 label",function(){
//   var current_var_click = $(this).data('name');
//   var eachoption3val = '';
//   var eachoption2val = '';
//   var checkSecondOp = true;
//   $('.product-form__input--dropdown.option2 label').each(function(){
//     var eachoption2val = current_var_click +'-'+ $(this).data('name');
//     var index = eachvalarray.findIndex((x) => (x).includes(eachoption2val));
//     console.log(eachvalarray);
//     if(index > -1){
//       $(this).show().addClass('is-active');
//     } else{
//       $(this).hide().removeClass('is-active');
//     }
//     if(length_options == 3){      
//       eachoption2val = $('.product__desc__var_quan_row variant-radios fieldset.option2 input:checked').data('swatch-title');
//       //eachoption2val = $(this).data('name');    
//       $('.product-form__input--dropdown.option3 label').each(function(){         
//         eachoption3val = current_var_click +'-'+ eachoption2val +'-'+ $(this).data('name');
//         var index = eachvalarray.findIndex((x) => x == eachoption3val);
//         if(index > -1){
//           $(this).show().addClass('is-active');
//         } else{
//           $(this).hide().removeClass('is-active');
//         }
//       });
//     } else{     
//       var eachoption2val = current_var_click +'-'+ $(this).data('name');
//       var index = eachvalarray.findIndex((x) => (x).includes(eachoption2val));
//       if(index > -1){
//         $(this).show().addClass('is-active');
//       } else{
//         $(this).hide().removeClass('is-active');
//       }
//     }
//   });
//   if(length_options == 3){
//     setTimeout(function() {
//       $('.product-form__input--dropdown.option2 label').each(function(){
//        if($(this).hasClass('is-active')){      
//         if(checkSecondOp){
//           $(this).trigger('click'); 
//           checkSecondOp = false;
//         }
//        }
//       })
//     }, 50);
//   }
// });
// if(length_options == 3){
//   $(document).on("click",".product-form__input.option2 label:not(.disabled)",function(){
//     var lavel_1_seleted = $('.product__desc__var_quan_row variant-radios fieldset.option1 input:checked').data('swatch-title');
//     var lavel_2_seleted = $(this).data('name');
//     $('.product-form__input--dropdown.option3 label').each(function(){  
//       var check2val = lavel_1_seleted +'-'+ lavel_2_seleted +'-'+ $(this).data('name');      
//       var index2 = eachvalarray.findIndex((x) => x == check2val);
//       if(index2 > -1){
//         $(this).show().addClass('is-active');
//       } else{
//         $(this).removeClass('is-active');
//       }
//     });    
//   });
// }

// $(window).on("load", function(){
//   var length_options = $('.product__desc__var_quan_row variant-radios fieldset').length;
//   if(length_options > 1){
//     $(".product-form__input--dropdown.option1 label:eq( 0 )").trigger('click');
//   }
//   recursive();

//   var current_var_click = $(".product__desc__var_quan_row .variant_values label").eq(0).data('name');
//   var eachvalarray = [];
//   $('.select__select___ option').each(function(){
//     var eachval = $(this).data('label');         
//     eachvalarray.push(eachval);
//   });
//   $('.product-form__input--dropdown.option2 label').each(function(){
//     var eachoption2val = current_var_click +'-'+ $(this).data('name');
//     var index = eachvalarray.findIndex((x) => (x).includes(eachoption2val));
//     if(index > -1){
//       $(this).show().addClass('is-active');
//     } else{
//       $(this).hide().removeClass('is-active');
//     }
//   }); 
// });

window.addEventListener('DOMContentLoaded', async () => {
  const breadCrumbElement = document.getElementById('breadCrumbProductCollection');
  const collectionSlash = document.getElementById('bcpcSlash');

  if (!breadCrumbElement || !collectionSlash) {
    console.warn('Breadcrumb elements not found in DOM.');
    return;
  }

  const referrer = document.referrer;
  if (!referrer || !referrer.includes('/collections/')) {
    console.info('No valid collection referrer found.');
    breadCrumbElement.remove();
    return;
  }

  try {
    const response = await fetch(`${referrer}.json`, {
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Fetch failed: ${response.status} ${response.statusText}`);
    }

    const textData = await response.text();

    let data;
    try {
      data = JSON.parse(textData);
    } catch (parseError) {
      throw new Error('Could not parse JSON from referrer.');
    }

    if (data?.collection?.title) {
      breadCrumbElement.innerHTML = `
        <a href="${referrer}" itemprop="name" property="item" typeof="WebPage" aria-current="page">
          <span itemprop="name">${data.collection.title}</span>
          <meta itemprop="position" content="2" />
        </a>`;
      collectionSlash.style.display = 'inline';
    } else {
      breadCrumbElement.remove();
    }

  } catch (error) {
    breadCrumbElement.remove();
  }
});